import { useMemo } from 'react';
import { useMsal } from '@azure/msal-react';

/**
 * Hook to check if the current user has a specific claim
 * @param claimName The name of the claim to check
 * @returns true if the user has the claim with a truthy value, false otherwise
 */
export function useUserClaim(claimName: string): boolean {
    const { accounts } = useMsal();

    return useMemo(() => {
        if (accounts.length === 0) return false;

        const account = accounts[0];
        if (!account?.idTokenClaims) return false;

        const claims = account.idTokenClaims as any;
        const claimValue = claims[claimName];

        // Check for both boolean true and string 'true'
        return claimValue === true || claimValue === 'true';
    }, [accounts, claimName]);
}
